import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import YoutubeVideos from './YoutubeVideos';
import VideoPage from './VideoPage';
import Contact from './Contact';
import Sidebar from './Sidebar';
import episodes from './episodes';

function App() {
  return (
    <Router>
      <div className='App'>
        <header className='App-header'>
          <Routes>
            <Route
              path='/'
              element={
                <>
                  <YoutubeVideos videos={episodes} />
                  <Sidebar />
                </>
              }
            />
            <Route path='/contact' element={<Contact />} />
            <Route
              path='/watch/:videoId'
              element={<VideoPage videos={episodes} />}
            />
          </Routes>
        </header>
      </div>
    </Router>
  );
}

export default App;
